export default __webpack_public_path__ + "static/media/td.7613bd02.svg";